import { Group, Stack, Text } from '@mantine/core';
import Card from 'components/Card';
import dayjs from 'dayjs';
import React from 'react';
import { HiOutlineClock } from 'react-icons/hi';
import { BasicInformation } from 'types/lcms/courses';

interface ScheduleSectionProps {
  data?: BasicInformation;
}

const ScheduleSection: React.FC<ScheduleSectionProps> = ({ data }) => {
  return (
    <Card>
      <Stack gap={16}>
        <Group gap={8}>
          <HiOutlineClock />
          <Text c={'dark'} fw={700}>
            Timeline
          </Text>
        </Group>
        <Group justify='space-between'>
          <Stack gap={0} flex={1}>
            <Text c={'grey.5'} fw={600} fz={14}>
              Start Time
            </Text>
            <Text fz={14} c={'dark'}>
              {data?.startDateTime ? dayjs(data.startDateTime).format('DD MMMM YYYY') : '-'}
            </Text>
          </Stack>
          <Stack gap={0} flex={1}>
            <Text c={'grey.5'} fw={600} fz={14}>
              Start Time
            </Text>
            <Text fz={14} c={'dark'}>
              {data?.endDateTime ? dayjs(data.endDateTime).format('DD MMMM YYYY') : '-'}
            </Text>
          </Stack>
        </Group>
        <Group justify='space-between'>
          <Stack gap={0}>
            <Text c={'grey.5'} fw={600} fz={14}>
              Duration
            </Text>
            <Text fz={14} c={'dark'}>
              {data?.startDateTime && data?.endDateTime
                ? dayjs(data.endDateTime).diff(data.startDateTime, 'day') + ' days'
                : '-'}
            </Text>
          </Stack>
        </Group>
      </Stack>
    </Card>
  );
};

export default ScheduleSection;
